export default __webpack_public_path__ + "static/media/laptopback.79eea9d9.png";